import React, { useEffect, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import AOS from 'aos';
import routes from './pages';
import '../src/assets/fonts/font-awesome.css';
import Header from './components/header';
import 'url-search-params-polyfill';
import './App.scss';
import Footer from './components/footer';

function App() {
  const isMaintenance = false; // (unused but kept)
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Header />
      <Suspense fallback={null}>
        <Routes>
          {routes.map((r, i) => (
            <Route key={i} path={r.path} element={r.component} />
          ))}
        </Routes>
      </Suspense>
      <Footer />
    </>
  );
}

export default App;
